import type {
    Faq,
    Guarantee,
    Review
} from '@/types'

export const reviewStats = {
    rating: "4.9",
    count: "1,240",
    countValue: 1240,
    mentions: [
        { label: "Arrived when promised", count: 412 },
        { label: "Paid exactly what was quoted", count: 388 },
        { label: "Explained what was wrong", count: 301 }
    ]
}

export const reviews: Review[] = [
    {
        quote: "Spring snapped at 6 AM. Door was working before I left for work.",
        name: "Dana R.",
        town: "Millbrook",
        type: "Repair"
    },
    {
        quote: "Quoted $289 on the phone, paid $289. That never happens.",
        name: "Marcus T.",
        town: "Fairhaven",
        type: "Repair"
    },
    {
        quote: "They found it was just the sensors. Charged me for a 15-minute visit and showed me how to fix it next time.",
        name: "Priya S.",
        town: "Riverton"
    },
    {
        quote: "New carriage door went in Tuesday, neighbors were asking about it by Wednesday.",
        name: "Glenn W.",
        town: "Ashford Park",
        type: "New door"
    }
]

export const homeReviews: Review[] = reviews.slice(0, 3)

export const aboutReviews: Review[] = [reviews[0], reviews[1], reviews[3]]

export const guarantees: Guarantee[] = [
    { title: "Springs covered for life", body: "Should a spring we fitted ever break, the replacement part costs you nothing for as long as you own the home." },
    { title: "Two years on our labor", body: "Every repair carries it. If our work fails, we come back and put it right at no charge." },
    { title: "A fixed price, in writing", body: "The price arrives on your phone before we start, and that is the price you pay." },
    { title: "Our own background-checked team", body: "Every technician is on our payroll, in uniform and driving a marked truck. We never send subcontractors." },
    { title: "Licensed & insured", body: "License #GD-004417, insured to $2 million." },
    { title: "We clean up after ourselves", body: "Old parts and old doors leave with us, and the floor gets swept before we go." }
]

export const faqs: Faq[] = [
    {
        question: "Is it safe to open the door with a broken spring?",
        answer: "No. The spring carries the door's weight, so without it the opener strains and the door can come down hard. If the door is closed, pull the red cord to disconnect the opener, leave the door shut and give us a call."
    },
    {
        question: "Is there a call-out fee?",
        answer: "A $59 diagnostic fee applies, and it is waived when we carry out the repair. You'll hear about it before we set off, never after."
    },
    {
        question: "Only one spring broke. Why change both?",
        answer: "The pair went in together and has done exactly the same number of cycles. The second one usually gives out within months, so replacing both saves you another visit."
    },
    {
        question: "How long does a new door take from start to finish?",
        answer: "The measure takes around 20 minutes. Most doors arrive within 1–3 weeks, and fitting takes 4–6 hours including taking the old door away."
    },
    {
        question: "Which opener brands can you repair?",
        answer: "Every major residential brand, older models included. If the parts for yours are no longer made, we'll say so on the spot."
    },
    {
        question: "Can you come out at the weekend?",
        answer: "Yes, on Saturdays from 8 AM to 6 PM. The emergency line runs every day until 10 PM."
    }
]

export const companyStats: { value: number, display: string, suffix?: string, label: string }[] = [
    { value: 2011, display: "2011", label: "Founded" },
    { value: 14200, display: "14,200", suffix: "+", label: "Doors put right" },
    { value: 9, display: "9", label: "Technicians on staff" },
    { value: 6, display: "6", label: "Trucks on the road" }
]

export const values: { title: string, body: string }[] = [
    { title: "The price comes first.", body: "A written price reaches you before a single tool comes out, and it stays the price." },
    { title: "We find the real fault.", body: "A door that keeps leaving its track is doing it for a reason. We track that reason down and fix it." },
    { title: "We leave it tidier.", body: "Old parts go with us, the floor gets swept and the opener is reset before we drive away." }
]
